<template>
  <section class="locale-section">
    <div class="locale-section__label">
      <div class="locale-section__label-text">
        {{ localeSectionLabel }}
      </div>
      <HelpTooltip>
        <template #title>
          {{ localeSectionLabel }}
        </template>
        <template #description>
          {{ localeSectionDescription }}
        </template>
      </HelpTooltip>
    </div>
    <div class="locale-section__list">
      <button
        v-for="locale in locales"
        :key="locale.code"
        :class="[
          'locale-section__list-item-button',
          isLocaleActive(locale.code),
        ]"
        @click="stageLocaleChanges(locale.code, localeType)"
      >
        {{ locale.name }}
      </button>
    </div>
  </section>
</template>

<script>
import HelpTooltip from '@/components/generics/HelpTooltip.vue'
export default {
  components: {
    HelpTooltip,
  },
  props: {
    locales: {
      type: Array,
      required: true,
    },
    localeType: {
      type: String,
      required: true,
    },
    contentLocale: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  emits: ['stageLocaleChanges'],
  computed: {
    localeSectionLabel() {
      return this.localeType === 'system'
        ? this.$t('mainMenu.language.SYSTEM_LANGUAGE')
        : this.$t('mainMenu.language.CONTENT_LANGUAGE')
    },
    localeSectionDescription() {
      return this.localeType === 'system'
        ? this.$t('mainMenu.language.SYSTEM_LANGUAGE_DESCRIPTION')
        : this.$t('mainMenu.language.CONTENT_LANGUAGE_DESCRIPTION')
    },
  },
  methods: {
    isLocaleActive(localeCode) {
      return this.localeType === 'system'
        ? this.isSystemLocaleActive(localeCode)
        : this.isContentLocaleActive(localeCode)
    },
    isSystemLocaleActive(localeCode) {
      return this.$i18n.locale === localeCode
        ? 'locale-section__list-item-button--active'
        : ''
    },
    isContentLocaleActive(localeCode) {
      return this.contentLocale === localeCode
        ? 'locale-section__list-item-button--active'
        : ''
    },
    stageLocaleChanges(localeCode, localeType) {
      const payload = { localeCode, localeType }
      this.$emit('stageLocaleChanges', payload)
    },
  },
}
</script>

<style lang="scss" scoped>
.locale-section {
  &__label {
    display: flex;
    gap: $spacing-5xs;
    margin-bottom: $spacing-4xs;
  }
  &__label-text {
    @include formLabelStyle;
  }
  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: $spacing-4xs;
  }
  &__list-item-button {
    background: $color-canvas;
    border: 2px solid $color-border;
    border-radius: $border-radius-2xl;
    color: $color-text;
    line-height: 1;
    padding: $spacing-5xs $spacing-3xs;
    outline-color: $color-navigation;
    outline-offset: $spacing-5xs;
    font-size: 14px;
    cursor: pointer;
  }
  &__list-item-button:hover,
  &__list-item-button--active {
    border-color: $color-blue-60;
    color: $color-text;
  }
}
</style>
